module.exports = __webpack_public_path__ + "static/media/5_4.ad0ada40.png";